import * as React from "react";
const SvgAuthBg = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={1920}
    height={244}
    fill="none"
    viewBox="0 0 1920 244"
    preserveAspectRatio="none"
    {...props}
  >
    <g clipPath="url(#authBg_svg__a)">
      <path fill="#fff" d="M1920 0H0v234h1920z" />
      <g filter="url(#authBg_svg__b)">
        <path
          fill="url(#authBg_svg__c)"
          d="M21.818 227.034 43.636 234l21.819-6.966L87.273 234l21.818-6.966L130.909 234l21.818-6.966L174.545 234l21.819-6.966L218.182 234 240 227.034 261.818 234l21.818-6.966L305.455 234l21.818-6.966L349.091 234l21.818-6.966L392.727 234l21.818-6.966L436.364 234l21.818-6.966L480 234l21.818-6.966L523.636 234l21.819-6.966L567.273 234l21.818-6.966L610.909 234l21.818-6.966L654.545 234l21.819-6.966L698.182 234 720 227.034 741.818 234l21.818-6.966L785.455 234l21.818-6.966L829.091 234l21.818-6.966L872.727 234l21.818-6.966L916.364 234l21.818-6.966L960 234l21.818-6.966L1003.64 234l21.81-6.966 21.82 6.966 21.82-6.966 21.82 6.966 21.82-6.966 21.82 6.966 21.81-6.966 21.82 6.966 21.82-6.966 21.82 6.966 21.82-6.966 21.81 6.966 21.82-6.966 21.82 6.966 21.82-6.966 21.82 6.966 21.82-6.966 21.81 6.966 21.82-6.966L1440 234l21.82-6.966 21.82 6.966 21.81-6.966 21.82 6.966 21.82-6.966 21.82 6.966 21.82-6.966 21.82 6.966 21.81-6.966 21.82 6.966 21.82-6.966 21.82 6.966 21.82-6.966 21.81 6.966 21.82-6.966 21.82 6.966 21.82-6.966 21.82 6.966 21.82-6.966 21.81 6.966 21.82-6.966L1920 234V0H0v234z"
        />
      </g>
    </g>
    <defs>
      <linearGradient
        id="authBg_svg__c"
        x1={1920}
        x2={0}
        y1={117}
        y2={117}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#082B60" />
        <stop offset={1} />
      </linearGradient>
      <clipPath id="authBg_svg__a">
        <path fill="#fff" d="M0 0h1920v244H0z" />
      </clipPath>
      <filter
        id="authBg_svg__b"
        width={1920}
        height={244}
        x={0}
        y={0}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={10} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0.0313726 0 0 0 0 0.168627 0 0 0 0 0.376471 0 0 0 0.15 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_3034_50" />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_3034_50"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);
export default SvgAuthBg;
